(function () {
    var MODAL = '#search-modal';
    var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
    var LABEL_CLASS = 'snize-section-label';
    var VIEW_ALL_CLASS = 'snize-view-all-row';
    var RELOCATED_ATTR = 'data-snize-view-all-relocated';

    var SECTION_LABELS = /^POPULAR\s+SUGGESTIONS$|^PRODUCTS$|^SUGGESTIONS$|^CATEGORIES$|^PAGES$/i;
    var VIEW_ALL_TEXT = /view\s+all|see\s+all/i;

    var VIEW_ALL_SELECTORS =
      '.snize-view-all-link, .snize-view-all, .snize-ac-view-all, a[class*="view-all"], ' +
      '.snize-show-all, .snize-show-more';

    function isMobile() {
      return MOBILE_MQ.matches;
    }

    function isSectionLabel(el) {
      if (!(el instanceof Element)) return false;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text.length || text.length > 40) return false;
      if (SECTION_LABELS.test(text)) return true;
      if (el.matches('.snize-title, .snize-header, .snize-overline, .snize-section-title')) {
        return true;
      }
      return false;
    }

    function isViewAllRow(el) {
      if (!(el instanceof Element)) return false;
      if (el.matches(VIEW_ALL_SELECTORS)) return true;
      if (el.querySelector(VIEW_ALL_SELECTORS)) return true;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      return VIEW_ALL_TEXT.test(text);
    }

    function unhide(el) {
      if (!(el instanceof Element)) return;
      el.classList.remove('snize-hidden');
      var node = el;
      for (var depth = 0; depth < 4 && node; depth++) {
        node.classList.remove('snize-hidden');
        node = node.parentElement;
      }
    }

    function findProductsList(root) {
      var lists = root.querySelectorAll('ul');
      for (var i = 0; i < lists.length; i++) {
        if (lists[i].querySelector('.snize-product')) return lists[i];
      }
      return null;
    }

    function relocateViewAll(root) {
      var viewAllNodes = root.querySelectorAll(
        VIEW_ALL_SELECTORS + ', li.snize-view-all-row, .snize-footer, .snize-view-all-wrapper'
      );

      var viewAll = null;
      for (var i = 0; i < viewAllNodes.length; i++) {
        var node = viewAllNodes[i];
        if (!isViewAllRow(node)) continue;
        viewAll = node.matches(VIEW_ALL_SELECTORS) ? node : node.querySelector(VIEW_ALL_SELECTORS) || node;
        break;
      }

      if (!viewAll) {
        var allLis = root.querySelectorAll('li, .snize-product');
        for (var j = 0; j < allLis.length; j++) {
          if (isViewAllRow(allLis[j])) {
            viewAll = allLis[j];
            break;
          }
        }
      }

      if (!viewAll) return;

      var row = viewAll.closest('li') || viewAll;
      if (!(row instanceof Element)) return;

      // Remove any previously-relocated view-all rows that are NOT this one.
      // Fixes the duplicate "VIEW ALL" CTA on subsequent searches — when
      // Searchanise re-renders, we tagged a fresh node but the old tagged
      // node was still sitting in the wrapper.
      root.querySelectorAll('[' + RELOCATED_ATTR + '="true"]').forEach(function (old) {
        if (old === row) return;
        if (old.parentElement) old.parentElement.removeChild(old);
      });
      root.querySelectorAll('.' + VIEW_ALL_CLASS).forEach(function (old) {
        if (old === row) return;
        if (old.getAttribute(RELOCATED_ATTR) !== 'true') return;
        if (old.parentElement) old.parentElement.removeChild(old);
      });

      row.classList.add(VIEW_ALL_CLASS);
      unhide(row);
      unhide(viewAll);

      if (row.getAttribute(RELOCATED_ATTR) === 'true') return;

      var productsUl = findProductsList(root);
      var insertParent = productsUl ? productsUl.parentElement : row.parentElement;
      if (!insertParent) return;

      if (productsUl && row.parentElement === productsUl) {
        insertParent.insertBefore(row, productsUl.nextSibling);
      } else if (row.parentElement !== insertParent) {
        insertParent.appendChild(row);
      }

      row.setAttribute(RELOCATED_ATTR, 'true');
    }

    function normalizeList(ul) {
      if (!(ul instanceof Element)) return;
      Array.from(ul.children).forEach(function (child) {
        if (isSectionLabel(child)) {
          child.classList.add(LABEL_CLASS);
          child.classList.remove('snize-suggestion');
        } else if (isViewAllRow(child)) {
          child.classList.add(VIEW_ALL_CLASS);
          unhide(child);
        }
      });
    }

    // Hide the chrome Searchanise injects on its own (mobile takeover panel,
    // duplicate search-box wrappers). Our single #cmdk-input is the only
    // input the user should see — anything else is leftover from
    // Searchanise's mobile overlay mode and would render as a duplicate
    // field if shown.
    function hideDuplicateSearchChrome(root) {
      if (!root) return;
      var selectors =
        '.snize-mobile-top-panel, #snize-mobile-search-input, .snize-search-box-wrapper, .snize-input-wrapper';
      root.querySelectorAll(selectors).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
      root.querySelectorAll('input[name="q"], input[type="search"]').forEach(function (input) {
        if (input.id === 'cmdk-input') return;
        input.style.setProperty('display', 'none', 'important');
      });
    }

    function normalize(root) {
      if (!root) return;
      hideDuplicateSearchChrome(root);
      root.querySelectorAll('ul').forEach(normalizeList);
      root.querySelectorAll(':is(.snize-column, .snize-block, .snize-popular-queries)').forEach(
        function (block) {
          Array.from(block.children).forEach(function (child) {
            if (isSectionLabel(child)) child.classList.add(LABEL_CLASS);
            if (isViewAllRow(child)) {
              child.classList.add(VIEW_ALL_CLASS);
              unhide(child);
            }
          });
        }
      );

      if (isMobile()) {
        relocateViewAll(root);
      }
    }

    function hasActiveQuery(modal) {
      var input = modal.querySelector('#cmdk-input');
      return !!(input && input.value && input.value.length > 0);
    }

    function stripSnizeHiddenOnQueryNodes(root) {
      if (!root) return;
      // Only un-hide products / view-all / section labels. Leave Searchanise's
      // own panel-level .snize-hidden flag alone so old results stay hidden
      // between search sessions.
      root.querySelectorAll(
        '.snize-product.snize-hidden, ' +
        '.snize-section-label.snize-hidden, ' +
        '.snize-view-all-row.snize-hidden, ' +
        'li.snize-product.snize-hidden'
      ).forEach(function (el) {
        el.classList.remove('snize-hidden');
      });
    }

    function run() {
      var modal = document.querySelector(MODAL);
      if (!modal) return;
      var dialog = modal.querySelector('dialog');
      if (!dialog || !dialog.open) return;
      normalize(modal);
      if (hasActiveQuery(modal)) {
        stripSnizeHiddenOnQueryNodes(modal);
      }
    }

    function start() {
      var modal = document.querySelector(MODAL);
      if (!modal) return false;
      run();
      new MutationObserver(run).observe(modal, { childList: true, subtree: true });
      return true;
    }

    if (!start()) {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    }

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', run);
    }
  })();
